// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-spline';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.424 17.424H.576V.576' />
    <path d='M17.424 8.28c-2.16.432-2.88-3.384-4.752-3.528-1.872-.216-4.32 4.32-6.192 4.32S3.168 4.752.792 5.328c-.072-.072-.144-.072-.216 0m0 10.584c2.376-.432 5.832-4.32 7.704-3.744 1.872.576 4.104 3.6 5.616 3.24 1.512-.288 3.384-3.888 3.384-3.888' />
    <path d='M17.424 3.024c-.504 1.872-2.376 8.28-5.256 7.848-2.808-.36-3.312-9-5.688-9-3.456 0-1.512 8.208-5.904 8.208' />
  </g>
);

export const viewBox = '0 0 18 18';
